import { render, staticRenderFns } from "./FairPlane.vue?vue&type=template&id=4aed6dc0"
import script from "./FairPlane.vue?vue&type=script&lang=js"
export * from "./FairPlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports